import React from 'react';
import PropTypes from 'prop-types';

import './DebiCheck.css';

// Components
import VettingCheckBoxPanel from '../VettingCheckBoxPanel/VettingCheckBoxPanel';

// Styled Components"
import {
  Subtitle2,
  Paragraph
} from '../../../StyledComponents';

// Icons
import {
  VettingDebiCheckIcon
} from "../Svg/index";

const DebiCheck = ({setDebiCheck, value}) => {
  return (
    < div className="vetting-debi-check-container" >
      <div className="vetting-debi-check-header">
        <span className="debiCheckIcon"><VettingDebiCheckIcon /></span>
        <Subtitle2
          style={{ marginTop: 0 }}
          automationidattr={`vetting debi check`}
        >
          DebiCheck
        </Subtitle2>
      </div>
      <Paragraph
        automationidattr={`Vetting DebiCheck Desc`}
      >
        To protect your account from fraudsters, DebiCheck lets you authorise debit orders electronically before transactions are processed. It&apos;s an extra layer of security for your peace of mind.
      </Paragraph>
      <VettingCheckBoxPanel
        value={value}
        label={`I would like Vodacom to perform a DebiCheck.`}
        inputIdentifier={`debiCheck`}
        key={`debiCheck`}
        onChange={setDebiCheck}
      />
    </div >
  )
}

DebiCheck.propTypes = {
  setDebiCheck: PropTypes.func.isRequired,
  value: PropTypes.string
}

export default DebiCheck;